<template>
  <div id="wrapper" class="noheader">
    <div class="content">
      <div class="caption">
        <div class="inner">
          <span></span>
          <p>木生婦幼診所</p>
          <span></span>
        </div>
        <a
          v-if="$store.state.from === '/FeedBack'"
          @click="backHome"
          class="arr"
          ><div class="inner"></div
        ></a>
      </div>
      <div class="surveyBox">
        <div class="title">
          <h2 style="text-align: center;">
            顧客滿意度調查
          </h2>
        </div>
        <p style="color: #999999; text-align: justify;">
          親愛的患者您好:
          <br />
          本院為提供更友善專業的醫療服務環境，懇請您利用幾分鐘的時間，填寫這份問卷。為保護您的權益，本問卷將由專人處理，問卷內容均予保密。
          <br />
          您的反饋是我們進步的動力，若您需要即刻地改善，請寫下姓名與電話，並請提供建議或改善事項，我們會盡快處理，感謝您的指教與支持。
        </p>
        <br />
        <div class="formBox">
          <form action="javascript:void(0);">
            <h3 style="text-align: center;">
              就診背景
            </h3>
            <br />
            <p style="display:inline;">
              您是否為初次來本院就診？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['初次來訪']">
              <option value="">請選擇下列選項</option>
              <option value="是">是</option>
              <option value="否">否</option>
            </select>
            <p style="display:inline;">
              您今日看診科別？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['看診科別']">
              <option value="">請選擇下列選項</option>
              <option value="婦產科">婦產科</option>
              <option value="小兒科">小兒科</option>
              <option value="其他門診">其他門診</option>
            </select>
            <br />
            <p style="display:inline;">
              您的就診日期？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <input
              v-model="survey['就診日期']"
              type="date"
              class="inputBox line"
            />
            <br />
            <p style="display:inline;">
              您的就診時別？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['診別']">
              <option value="">請選擇下列選項</option>
              <option value="上午診">上午診</option>
              <option value="下午診">下午診</option>
              <option value="夜診">夜診</option>
            </select>
            <br />
            <p style="display:inline;">
              您是從何得知木生婦幼診所(複診者略過)
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <div class="checksBox">
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="親友介紹"
                />
                <div class="box"></div>
                親友介紹</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="網路搜尋"
                />
                <div class="box"></div>
                網路搜尋</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="FB/IG"
                />
                <div class="box"></div>
                FB/IG</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="其他社群(Dcard、Threads、PTT...)"
                />
                <div class="box"></div>
                其他社群(Dcard、Threads、PTT...)</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="Google評論"
                />
                <div class="box"></div>
                Google評論</label
              >
              <br />
              <label class="checkMC"
                ><input
                  v-model="survey['得知管道']"
                  type="radio"
                  value="地標顯眼"
                />
                <div class="box"></div>
                地標顯眼</label
              >
            </div>
            <h3 style="text-align: center;">
              看診體驗
            </h3>
            <br />
            <div
              v-for="(questionSet, number) in satisfactoinQuestion"
              :key="number"
            >
              <b>
                {{ satisfactoinTitle[number] }}
              </b>
              <b style="color: red;" v-if="false">（必填）</b>
              <br />
              <br />
              <div v-for="question in questionSet" :key="question">
                <p style="color: #999999; display:inline;">
                  {{ question }}
                </p>
                <p style="color: red; display:inline-block;" v-if="question === '若您遇到問題時，診所人員是否主動協助或傾聽'">（必填）</p>
                <br />
                <select v-model="survey[question]">
                  <option value="">請選擇下列選項</option>
                  <option value="滿意">滿意</option>
                  <option value="普通">普通</option>
                  <option value="不滿意">不滿意</option>
                </select>
              </div>
            </div>
            <!-- 總結 -->
            <h3 style="text-align: center;">
              其他
            </h3>
            <br />
            <p style="display:inline;">
              請您為本次就醫總體滿意度打一個分數
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['滿意度分數']">
              <option value="">請選擇下列選項</option>
              <option value="90分以上">90分以上</option>
              <option value="80-89分">80-89分</option>
              <option value="70-79分">70-79分</option>
              <option value="60-69分">60-69分</option>
              <option value="60分以下">60分以下</option>
            </select>
            <br />
            <p>
              本次就診，如有滿意的地方，請給我們鼓勵
            </p>
            <br />
            <textarea
              v-model="survey['建議做法']"
              placeholder="請提供改善建議"
            ></textarea>
            <br />
            <p>
              呈上，如有不滿意的地方，請告訴我們
            </p>
            <br />
            <textarea
              v-model="survey['不滿意描述']"
              placeholder="請填寫改善建議"
            ></textarea>
            <br />
            <p>
              如您願意嘉獎某位工作人員，請填寫您想告訴我們的姓名或特徵
            </p>
            <br />
            <input
              v-model="survey['嘉獎工作人員姓名']"
              type="text"
              placeholder="姓名"
              class="inputBox line"
            />
            <br />
            <br />
            <p>
              如您希望投訴某位工作人員，請填寫您想告訴我們的姓名或特徵
            </p>
            <br />
            <input
              v-model="survey['被投訴員工姓名']"
              type="text"
              placeholder="姓名"
              class="inputBox line"
            />
            <br />
            <br />
            <p style="display:inline;">
              請問您是否願意推薦木生診所給您的親友？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['是否推薦']">
              <option value="">請選擇下列選項</option>
              <option value="願意">願意</option>
              <option value="普通">普通</option>
              <option value="不願意">不願意</option>
            </select>
            <br />
            <p style="display:inline;">
              如果您再次需要醫療服務的話，您會選擇？
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['再次選擇']">
              <option value="">請選擇下列選項</option>
              <option value="會再繼續來木生">會再繼續來木生</option>
              <option value="尚未決定">尚未決定</option>
              <option value="會換其他醫療院所">會換其他醫療院所</option>
            </select>
            <br />
            <p style="display:inline;">
              本份問卷是由
            </p>
            <p style="color: red; display:inline-block;">（必填）</p>
            <br />
            <br />
            <select v-model="survey['填寫人']">
              <option value="">請選擇下列選項</option>
              <option value="患者本人填寫">患者本人填寫</option>
              <option value="親友代填">親友代填</option>
            </select>
            <p style="color: #999999; text-align: justify;">
              問卷到此告一段落 : ) 再次感謝您的耐心分享，
              您的批評與指教是我們最寶貴的禮物。<br />
              木生全體醫護人員，在此向您鞠躬致謝。<br />
              祝願您擁有美好的一天！
            </p>
            <br />
            <input
              @click.prevent="submitForm"
              type="submit"
              class="submitBtn"
              value="確認送出"
            />
          </form>
        </div>
      </div>
    </div>
  </div>
  <modal v-if="modal.display" @close="closeModal">
    <template #header>{{ modal.header }}</template>
    <template #body>{{ modal.body }}</template>
  </modal>
</template>
<script>
import { reactive, ref } from "vue";
import { useRouter } from "vue-router";
const returnRouter = () => {
  const router = useRouter();

  const goTo = destination => {
    router.replace(destination);
  };
  return {
    goTo
  };
};
import store from "../../store/index.js";
import api from "../../api";
export default {
  setup() {
    const { goTo } = returnRouter();
    const survey = ref({
      得知管道: ""
    });
    const modal = reactive({});
    const satisfactoinTitle = reactive([
      "看診體驗",
      "專業度評價(未接觸過人員者免填)",
      "服務態度指標(未接觸過人員者免填)"
    ]);
    const satisfactoinQuestion = ref([
      [
        "整體看診流程是否順暢度(包含順暢度、看診時間等)",
        "接受診療時保有自己的隱私性",
        "診所環境與整潔度"
      ],
      [
        "醫生看診專業度(如：病情說明、診療方式的清楚度)",
        "超音波技師專業度(如超音波及說明)",
        "藥師的專業度（如：用藥說明清楚程度）",
        "護理人員專業度(如：問診、護理指導與專業表現)"
      ],
      [
        "超音波技師檢測及說明的態度",
        "藥師用藥說明時的態度",
        "護理人員服務態度(包含診間與其他護理人員)",
        "櫃台人員的服務態度(包含掛號批價等)",
        "保全人員的服務態度",
        "若您遇到問題時，診所人員是否主動協助或傾聽"
      ]
    ]);

    function submitForm() {
      const checkingList = [
        [survey.value['初次來訪'], "是否初次來訪"],
        [survey.value['看診科別'], "看診科別"],
        [survey.value['就診日期'], "就診日期"],
        [survey.value['診別'], "就診時別"],
        [survey.value['滿意度分數'], "滿意度分數"],
        [survey.value['是否推薦'], "是否推薦"],
        [survey.value['再次選擇'], "再次選擇"],
        [survey.value['填寫人'], "填寫人"],
        [survey.value['若您遇到問題時，診所人員是否主動協助或傾聽'], "若您遇到問題時，診所人員是否主動協助或傾聽"]
      ];

      let passChecking = true;
      checkingList.forEach(item => {
        passChecking = passChecking && item[0];
      });

      if (!passChecking) {
        let bodyMessage = "請補足以下欄位：\n";
        checkingList.forEach(item => {
          if (!item[0]) {
            bodyMessage = bodyMessage + item[1] + "\n";
          }
        });
        modal.display = true;
        modal.header = "必填欄位缺失";
        modal.body = bodyMessage;
        return;
      }

      api.surveyForm
        .create({
          jwt: store.state.member.jwt,
          type: "門診部",
          data: survey.value
        })
        .then(data => {
          console.log(data);
          Object.assign(modal, {
            type: "success",
            display: true,
            header: "表單填寫成功",
            body: "感謝您的耐心填寫。"
          });
        })
        .catch(error => {
          Object.assign(modal, {
            type: "fail",
            display: true,
            header: "填寫異常",
            body: error.message
          });
        });
    }

    function backHome() {
      goTo("/FeedBack");
    }

    function closeModal() {
      if (modal.type === "success" && store.state.from === "/FeedBack") {
        goTo("/Feedback");
        return;
      }
      modal.display = false;
    }

    return {
      backHome,
      survey,
      satisfactoinQuestion,
      submitForm,
      satisfactoinTitle,
      modal,
      closeModal
    };
  }
};
</script>
